/** @jsxImportSource @emotion/react */
import React from "react";
import { GlobalStore } from "../../../store/global/GlobalStore";
import styled from "@emotion/styled";
import { Button } from "../../../components/general/Button/Button";
import { css } from "@emotion/react";
import { motion } from "framer-motion";
import { YouPaySection } from "./YouPaySection";
import { openTransactionInBlockExplorer } from "../../../utils/txUtils";
import { getIsWrapOrUnwrap } from "../../../utils/tokenSelectorUtils";
import { Text } from "../../../components/general/Text";
import { ReactComponent as ViewBlock } from "../../../img/butter_svgs/ViewBlock.svg";
import { resetOrderAndApprovalState } from "../../../components/ResetButton/ResetButton";
import { visibilityVariants } from "./YouReceiveSection";
import { calculateUsdTradeSurplus } from "../../../utils/orderUtils";

export const OrderCompletedBottomSection: React.FC = () => {
  const { makerTokens, takerTokens, network, order, wrapQuote, quote } = GlobalStore.useState(s => {
    return {
      makerTokens: s.makerTokens,
      takerTokens: s.takerTokens,
      network: s.network,
      order: s.order,
      wrapQuote: s.wrapQuote,
      quote: s.quote,
    };
  });
  const txHash = getIsWrapOrUnwrap(
    takerTokens.map(t => t.token),
    makerTokens.map(t => t.token),
    network
  )
    ? wrapQuote?.hash
    : order?.txHash;
  const tradeSurplus = calculateUsdTradeSurplus(order, quote);
  return (
    <OrderCompletedBottomContainer>
      <VisibilityContainer
        variants={visibilityVariants}
        initial="enter"
        animate="animate"
        custom={tradeSurplus}
      >
        <YouPaySection />
        <ButtonsContainer>
          <div
            css={css`
              display: flex;
              justify-content: center;
              align-items: flex-start;
              gap: 10px;
              width: 100%;
            `}
          >
            {/* Removing temporarily since /activity is disabled for Jam release */}
            {/* <Button
            buttonType="link"
            onClick={() => navigate(BEBOP_ROUTES.Activity)}
            widthExpand={true}
            buttonCss={css`
              display: flex;
              padding: 10px 14px 10px 8px;
              justify-content: center;
              align-items: center;
              align-self: stretch;
            `}
          >
            <Activity />
            <Text textStyle="Button" size={"Medium"}>
              Show in activity
            </Text>
          </Button> */}
            <Button
              buttonType="link"
              onClick={() => openTransactionInBlockExplorer(network.id, txHash ?? "")}
              widthExpand={true}
              buttonCss={css`
                display: flex;
                padding: 10px 14px 10px 8px;
                justify-content: center;
                align-items: center;
                align-self: stretch;
              `}
            >
              <ViewBlock />
              <Text textStyle="Button" size={"Medium"}>
                View in explorer
              </Text>
            </Button>
          </div>
          <Button
            buttonType="primary"
            text="New trade"
            textSize="Large"
            onClick={resetOrderAndApprovalState}
            widthExpand={true}
            buttonCss={css`
              display: flex;
              padding: 19px 18px;
              justify-content: center;
              align-items: center;
              align-self: stretch;
            `}
          />
        </ButtonsContainer>
      </VisibilityContainer>
    </OrderCompletedBottomContainer>
  );
};

const VisibilityContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
export const OrderCompletedBottomContainer = styled(motion.div)`
  display: flex;
  padding: 6px 0px 28px 0px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  align-self: stretch;
  border-radius: 0 0 36px 36px;
  background: ${props => props.theme["Dark mode"]["1700"]};
  position: relative;
  width: 100%;
`;

const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 20px 26px 0 26px;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;
